import { sha256 } from 'js-sha256'

function hasLeadingZeroBits(hex: string, bits: number): boolean {
  const nibbles = Math.floor(bits / 4)
  const rem = bits % 4

  for (let i = 0; i < nibbles; i++) {
    if (hex[i] !== '0') return false
  }

  if (rem > 0) {
    const val = parseInt(hex[nibbles], 16)
    if (val >= 1 << (4 - rem)) return false
  }

  return true
}

const BATCH = 2048

export async function solve(nonce: string, difficulty: number): Promise<string> {
  let counter = 0

  return new Promise((resolve) => {
    const tick = () => {
      for (let i = 0; i < BATCH; i++) {
        const c = String(counter++)
        const hash = sha256(nonce + c)
        if (hasLeadingZeroBits(hash, difficulty)) {
          resolve(c)
          return
        }
      }
      setTimeout(tick, 0)
    }
    tick()
  })
}
